/**
 * Zip packaging via fflate. Produces the bytes for a `.mcaddon` (a zip
 * containing the behavior and resource pack folders).
 */

import { strToU8, zipSync, type Zippable } from "fflate";
import type { ExportFile } from "./files";

export function filesToZipBytes(files: ExportFile[]): Uint8Array {
  const zippable: Zippable = {};
  for (const file of files) {
    zippable[file.path] = typeof file.content === "string" ? strToU8(file.content) : file.content;
  }
  // Level 6 is a good size/speed tradeoff for text-heavy packs.
  return zipSync(zippable, { level: 6 });
}

export function bytesToBlob(bytes: Uint8Array, type = "application/zip"): Blob {
  // Copy into a fresh ArrayBuffer-backed view so Blob accepts it cleanly.
  return new Blob([bytes.slice()], { type });
}
